import Vue from "vue";
import component from "./TaskDetail.vue";

const taskDetail = () => {
  let instance = null;
  const init = () => {
    const Detail = Vue.extend(component);
    component.install = (data => {
      instance = new Detail({
        data
      }).$mount();

      document.body.appendChild(instance.$el);
    })();
  };
  const install = opts => {
    if (!instance) {
      init(opts);
    }
    Vue.nextTick(() => {
      instance.open(opts);
    });
  };

  Vue.prototype.$taskDetail = install;
};

export default taskDetail;
